/**
 * ToggleGroup Component
 * The house-standard container for a cluster of boolean toggles: a bordered,
 * optionally-titled box that stacks its children (typically LabeledSwitch rows)
 * with a Divider between each and uniform vertical padding. Use this instead of
 * hand-rolling a bordered Box + overline + Dividers so every toggle group across
 * the app shares the same spacing/indent.
 *
 * Children that render null/false are filtered out, so a conditionally-omitted
 * toggle never leaves a stray divider.
 */

import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

function ToggleGroup({ title, children, sx }) {
  const items = React.Children.toArray(children).filter(Boolean);
  if (items.length === 0) return null;
  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, px: 2, py: 0.5, ...sx }}>
      {title && (
        <Typography
          variant="overline"
          color="text.secondary"
          sx={{ display: 'block', pt: 1, pb: 0.5 }}
        >
          {title}
        </Typography>
      )}
      {items.map((child, i) => (
        <React.Fragment key={child.key ?? i}>
          {i > 0 && <Divider />}
          <Box sx={{ py: 1 }}>{child}</Box>
        </React.Fragment>
      ))}
    </Box>
  );
}

export default ToggleGroup;
